export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13642.4373f9be.jpg";